import React, { useEffect } from 'react';
import { Trial } from '~/common/pages/Trial/Trial';
import { CONTENT_IDS } from '~/common/consts';
import { TrialContentProvider } from '~/common/provider/TrialContentProvider';
import { useAppStore } from '~/common/store/appStore';
import { useShallow } from 'zustand/react/shallow';

const Unified = () => {
  const { setContentId } = useAppStore(useShallow((state) => ({ setContentId: state.setContentId })));

  useEffect(() => {
    setContentId(CONTENT_IDS.BUSINESS);
  }, []);

  return (
    <TrialContentProvider>
      <Trial />
    </TrialContentProvider>
  );
};

export default Unified;
